import { Outlet } from "react-router";
import {
	SidebarInset,
	SidebarProvider,
	SidebarTrigger,
} from "@/components/ui/sidebar";
import { ImpersonationBanner } from "./ImpersonationControl";
import WorkspaceSidebar from "./WorkspaceSidebar";

export default function WorkspaceLayout() {
	return (
		<SidebarProvider>
			<WorkspaceSidebar />
			<SidebarInset className="relative flex h-svh flex-col overflow-hidden">
				<ImpersonationBanner />
				<div className="relative min-h-0 flex-1 overflow-hidden">
					<div className="absolute top-3 left-3 z-20">
						<SidebarTrigger className="border bg-background shadow-sm hover:bg-muted" />
					</div>
					<Outlet />
				</div>
			</SidebarInset>
		</SidebarProvider>
	);
}
